const appUrl = {
  baseUrl: "https://qa-zsport.appinsnap.com/VirtualCard",

  authPath: "/api/Account/login/web",
};
export default appUrl;
